module.exports = __webpack_public_path__ + "static/media/CY.e5682ca7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CY.svg
// module id = 235
// module chunks = 0